import { supabase } from '@/integrations/supabase/client';

import { createCRUDEntity } from '../crud-factory';
import { transformPageSEOData } from '../transformations';

// PageSEO Entity with custom helper method
export const PageSEO = createCRUDEntity('page_seo', transformPageSEOData, {
  customMethods: {
    // Helper method to find SEO by page key
    getByPageKey: async (pageKey: string, languageCode = 'en') => {
      const { data, error } = await supabase
        .from('page_seo')
        .select('*')
        .eq('page_key', pageKey)
        .eq('language_code', languageCode)
        .single();
      if (error && error.code !== 'PGRST116') throw error; // PGRST116 is "not found" error
      return data;
    },
  },
});
